import { render, staticRenderFns } from "./SvUploadLight.vue?vue&type=template&id=66908fa9&lang=pug&"
import script from "./SvUploadLight.vue?vue&type=script&lang=js&"
export * from "./SvUploadLight.vue?vue&type=script&lang=js&"
import style0 from "./SvUploadLight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports